import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Gallery } from "@/components/Gallery";
import { PageHeader, Spinner, EmptyState } from "@/components/common";

export default function GalleryPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data.filter((e) => (e.gallery || []).length > 0))).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gallery-page">
      <PageHeader caption="Captured Moments" title="Gallery" subtitle="A look back at the energy, the crowds and the music." />
      <div className="mx-auto max-w-7xl px-4 pb-10 sm:px-8">
        {loading ? <Spinner /> : events.length ? (
          <div className="space-y-14">
            {events.map((e) => (
              <div key={e.id}>
                <div className="mb-5 flex items-end justify-between">
                  <h2 className="font-serif text-2xl font-bold">{e.name}</h2>
                  <Link to={`/events/${e.id}`} className="text-sm text-[#E5C158] hover:underline">View event</Link>
                </div>
                <Gallery images={e.gallery} />
              </div>
            ))}
          </div>
        ) : <EmptyState text="No gallery photos have been added yet." />}
      </div>
    </div>
  );
}
